module.exports = __webpack_public_path__ + "static/media/5.ed306ef5.png";